<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe max-height="700"
      :show-summary="true" :summary-method="handleSummary">
      <template slot-scope="{ row }" slot="amount">
        <b>
          {{
            formatCurrency(row.amount ? row.amount : 0)
          }}
        </b>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DetailByItems',
  props: ['summary'],
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('report/serviceOrder', ['resources']),
    columns() {
      return [
        {
          title: this.$t('serviceRequestReport.no'),
          key: 'no',
          width: 60,
          render: (h, params) => {
            return h('span', [params.index + 1])
          },
          align: 'center'
        },
        {
          title: this.$t('serviceRequestReport.serviceDate'),
          key: 'service_request_date',
          minWidth: 115
        },
        {
          title: this.$t('serviceRequestReport.serviceRequestNumber'),
          key: 'service_request_no',
          minWidth: 150
        },
        {
          title: this.$t('serviceRequestReport.orderKads'),
          key: 'order_kads',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.serReqType'),
          key: 'service_request_type',
          minWidth: 160
        },
        {
          title: this.$t('serviceRequestReport.requestBy'),
          key: 'customer_name',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.feeType'),
          key: 'fee_type',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.technician1'),
          key: 'technician1_by',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.technician2'),
          key: 'technician2_by',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.plateNumber'),
          key: 'plate_number',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.informant'),
          key: 'informant_by',
          minWidth: 140
        },
        {
          title: this.$t('serviceRequestReport.serAdmin'),
          key: 'owner_by',
          minWidth: 150
        },
        {
          title: this.$t('serviceRequestReport.amount'),
          slot: 'amount',
          key: 'amount',
          minWidth: 140,
          align: 'right'
        }
      ]
    }
  },
  methods: {
    formatCurrency(amount) {
      return '$' + ' ' + new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }).format(amount)
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 2) {
          sums[key] = {
            key,
            value: this.$t('productNonMovingStock.total')
          }
          return
        }
        if (key === 'order_kads') {
          sums[key] = {
            key,
            value: this.summary.total_order_kads
          }
        } else if (key === 'service_request_type') {
          sums[key] = {
            key,
            value: this.summary.total_service_request_type
          }
        } else if (key === 'customer_name') {
          sums[key] = {
            key,
            value: this.summary.total_customer_name
          }
        } else if (key === 'technician1_by') {
          sums[key] = {
            key,
            value: this.summary.total_technician1_by
          }
        } else if (key === 'technician2_by') {
          sums[key] = {
            key,
            value: this.summary.total_technician2_by
          }
        } else if (key === 'plate_number') {
          sums[key] = {
            key,
            value: this.summary.total_plate_number
          }
        } else if (key === 'informant_by') {
          sums[key] = {
            key,
            value: this.summary.total_informant_by
          }
        } else if (key === 'owner_by') {
          sums[key] = {
            key,
            value: this.summary.total_owner_by
          }
        } else if (key === 'amount') {

          const totalAmount = this.formatCurrency(this.summary.total_amount)

          sums[key] = {
            key,
            value: totalAmount
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })
      return sums
    }
  }
}
</script>
<style>
.ivu-table-summary .ivu-table-cell {
  font-weight: bold;
}
</style>